import MainLayout from '@/components/layouts/main-layout';
import CategoriesList from '@/components/pages/home/categories-list';
import {FormattedMessage} from 'react-intl';
import type {FC} from 'react';

const CategoriesPage: FC = (): JSX.Element => (
  <MainLayout metadata={{title: 'Categories - Soubul'}}>
    <div className="flex flex-1 items-center justify-center">
      <section className="flex flex-wrap items-center container mx-auto py-16">
        <div className="w-full my-4">
          <p className="text-lg text-gray-500 font-semibold"><FormattedMessage id="words.get_teacher_trainer_mentor"/></p>
        </div>
        <CategoriesList />
      </section>
    </div>
  </MainLayout>
);

export default CategoriesPage;
